export const INSUFFICIENT_MAKER_BALANCE_ERR = 'INSUFFICIENT MAKER BALANCE';
export const SIGNATURE_ERR = 'User denied message signature';
export const USER_DENIED_TRANSACTION_SIGNATURE_ERR = 'User denied transaction signature';
export const INSUFFICIENT_ORDERS_TO_FILL_AMOUNT_ERR = 'There are not enough orders to fill this amount';
export const RELAYER_ERR = 'There was an error with the relayer';
export const INSUFFICIENT_FEE_BALANCE = 'INSUFFICIENT MAKER FEE BALANCE';
export const INSUFFICIENT_FEE_BALANCE_MSG = `You don't have enough 0x to pay fees`;
export const INSUFFICIENT_ETH_BALANCE_FOR_DEPOSIT = 'INSUFFICIENT_ETH_BALANCE_FOR_DEPOSIT';
export const UNEXPECTED_ERROR = 'An unexpected error happened';
